const NOTES_PREFIX = "sm_notes";

export const NOTES_WIDGET_TEST_IDS = {
    CONTAINER: `${NOTES_PREFIX}_container`,
    TITLE: `${NOTES_PREFIX}_title`,
    ITEM_LIST: `${NOTES_PREFIX}_item_list`,
    CONTENT_ITEM: `${NOTES_PREFIX}_content_item`,
    ICON: `${NOTES_PREFIX}_icon`,
};
